;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import type { ComponentPropsWithoutRef, ReactNode } from 'react'

type PageErrorTitleProps = ComponentPropsWithoutRef<'h1'> & {
  children: ReactNode
}

export function PageErrorTitle(props: PageErrorTitleProps) {
  return <h1 {...props} className="text-xl font-light" />
}
